import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { Box, Typography } from '@mui/material';
import logoIcon from 'assets/images/logo-icon.svg';

const HEADER_SX = {
  alignItems: 'center',
  bgcolor: 'background.brandSubtle',
  borderRadius: 2,
  boxShadow: 4,
  cursor: 'grab',
  display: 'flex',
  gap: 1.5,
  justifyContent: 'space-between',
  px: 1.5,
  py: 1.25,
  userSelect: 'none',
  mb: 1,
  border: 0.5,
} as const;

const TITLE_SX = {
  alignItems: 'center',
  display: 'flex',
  gap: 1,
  minWidth: 0,
} as const;

const LOGO_SX = {
  borderRadius: 5,
  height: 20,
  width: 40,
} as const;

const InterruptionsEmergencyHeader = () => (
  <Box sx={HEADER_SX}>
    <Box component="span" sx={TITLE_SX}>
      <NotificationsActiveOutlinedIcon sx={{ color: 'text.primary', fontSize: 18 }} />
      <Typography variant="subtitle1" color="textPrimary">
        Interruptions
      </Typography>
    </Box>
    <Box component="img" src={logoIcon} alt="Activity Agent" sx={LOGO_SX} />
  </Box>
);

export default InterruptionsEmergencyHeader;
